<template>
  <div class="container">
    <div class="d-flex justify-content-between align-items-center my-4">
      <h3>Controle de Usuários</h3>
      <b-alert
          style="position: fixed; right: 30px; top: 70px"
          dismissible
          fade
          :show="dismissCountDown"
          :variant="errorMessage.color"
          @dismissed="dismissed"
        >
          {{ errorMessage.text }}
        </b-alert>
      <!--<b-nav-form @submit.prevent="searchFieldAction(searchData)">
                <b-form-input v-model="searchData" v-on:keyup="searchFieldAction(searchData)"
                 size="sm" class="mr-sm-2" placeholder="Localizar proposta..."></b-form-input>
                 <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button> 
                </b-nav-form>
      <button class="btn btn-primary" title="Criar Nova Proposta">
        <font-awesome-icon :icon="['fas', 'plus']" style="cursor: pointer;"/>
      </button>-->
    </div>
    <hr />
    <div>
      <div class="text-center mt-5" v-if="preloader">
        <b-spinner
          variant="warning"
          type="grow"
          label="Large Spinner"
        ></b-spinner>
        <h5 class="lead">Carregando...</h5>
      </div>

      <h3 class="text-center lead mt-5" v-if="users == '' && !preloader">
        Nenhuma usuário encontrada
      </h3>

      <ul class="list-group list-group-flush">
        <li class="list-group-item" v-for="item of users" :key="item.id">
          <div class="">
            <div class="card-body">
              <img
                src="http://placehold.it/45x45"
                class="float-left rounded-circle"
              />
              <div class="message">
                <h6 class="card-title">{{ item.name }}</h6>
                <small class="card-subtitle mb-2 text-muted">
                  <i
                    class="fas fa-phone"
                    :class="{ 'text-primary' : item.phoneVerified }"
                    @click="handleValidPhone(item), item.phoneVerified = !item.phoneVerified"
                  ></i>
                  {{ item.phone }} -
                  <i
                    class="fas fa-at"
                    :class="{ 'text-primary' : item.emailVerified }"
                    @click="handleValidEmail(item), item.emailVerified = !item.emailVerified"
                  ></i>
                  {{ item.email }}
                  <br>
                  <small>
                    Criado em {{item.created.toDate().toLocaleDateString()}} às {{item.created.toDate().toLocaleTimeString()}}
                  </small>
                </small>
                <div class="float-right" title="Ativação do usuário">
                  <b-form-checkbox
                    switch
                    v-model="item.active"
                    @change="handleAccessUser(item)"
                    class="float-right"
                  >
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import axios from 'axios'
//var admin = require('firebase-admin');

export default {
  name: 'UsersListControl',
  data() {
    return {
      searchData: '',
      classCss: 'text-primary'
    };
  },
  methods: {
    ...mapActions(['searchFieldAction', 'getUsers', 'handleAccessUser', 'handleValidPhone', 'handleValidEmail', 'dismissed']),
    desactiveUser(item) {


      console.log('Clicado');

      const uid = item.uid

      console.log(uid);
      console.log(item);
      console.log(item.phone);
      console.log(item.email);
      console.log(item.disabled);
      console.log(item.emailVerified);

    }
  },
  computed: {
    ...mapState(['preloader', 'users', 'error', 'errorMessage', 'dismissCountDown']),
    ...mapGetters(['proposalFilterOfSearch'])
  },
  created() {
    this.getUsers();
  }
};
</script>

<style scoped>
ul {
  list-style: none;
}

ul li {
  padding: 5px 0;
}
h6 {
  margin: 0;
}
div .card-body {
  padding: 0.25rem;
}
.card-body .message {
  padding-left: 60px;
}

.card .card-body .actions {
  margin-top: 5px;
}
</style>
